// removed by extract-text-webpack-plugin
module.exports = {"ToggleSwitch":"ToggleSwitch","Label":"Label","Switch":"Switch","Slider":"Slider","Round":"Round"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ToggleSwitch/styles.scss
// module id = 1958
// module chunks = 10